import { Theme, css } from '@emotion/react';

import { Radius, Spacing, Typography } from 'chatie-design-system';

import Card from '@components/common/Card';
import SvgIcon from '@components/common/SvgIcon';

import IcPlusBold from '@public/icons/ic_plus_bold.svg';

const containerCSS = css`
  display: flex;
  flex: 1;
  width: 166px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${Spacing.large}px;

  ${Typography.h6};
  font-size: 12px;
  line-height: 16.2px;
  text-align: center;
`;

const plusCSS = (isCheming?: boolean) => (theme: Theme) =>
  css`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 60px;
    height: 60px;
    background: ${isCheming
      ? `${theme.colors.main500}`
      : `linear-gradient(90deg, #04c8d0 0%, #1590d5 95.45%)`};
    border-radius: ${Radius.round}px;
  `;

interface CharacterAddCardProps {
  handleOnClick: () => void;
  isCheming?: boolean;
}

const CharacterAddCard = ({
  handleOnClick,
  isCheming,
}: CharacterAddCardProps) => {
  return (
    <Card>
      <div css={containerCSS} onClick={handleOnClick}>
        <div css={plusCSS(isCheming)}>
          <SvgIcon icon={IcPlusBold} />
        </div>
        <p>
          내 캐릭터를
          <br />
          만들어 보세요 😋
        </p>
      </div>
    </Card>
  );
};

export default CharacterAddCard;
